// extracted by mini-css-extract-plugin
export default {"Container":"Counter_Container__qRuWV","Input":"Counter_Input__Vgm7V","ControlIcon":"Counter_ControlIcon__CCP6A","right":"Counter_right__7E5rI","left":"Counter_left__4URTN"};